<script setup>
import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';

defineProps({
  titleText: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  showDescription: {
    type: Boolean,
    required: true,
  },
  descriptionClass: {
    type: String,
    default: '',
  },
  titleAlign: {
    type: String,
    default: 'center',
    validator: value => ['left', 'center', 'right'].includes(value),
  },
});

const getters = useStoreGetters();
const globalConfig = computed(() => getters['globalConfig/get'].value);
</script>

<template>
  <div class="flex flex-col">
    <img
      :src="globalConfig?.logo"
      class="mx-auto hidden min-[960px]:block min-[960px]:w-[44px] min-[960px]:h-[48px] min-[1440px]:w-[74px] min-[1440px]:h-[80px] dark:min-[960px]:hidden"
    />

    <!-- Dark logo: show only >=960 in dark -->
    <img
      :src="globalConfig?.logoDark"
      class="mx-auto hidden min-[960px]:hidden min-[960px]:w-[44px] min-[960px]:h-[48px] min-[1440px]:w-[74px] min-[1440px]:h-[80px] dark:min-[960px]:block"
    />
    <!-- Title: 18px below 960px, 22px between 960-1440px, 32px above 1440px -->
    <h2
      class="font-bold text-[#2A2A2E] dark:text-woot-50 mt-6 text-center text-[18px] min-[960px]:text-[22px] min-[1440px]:text-[32px]"
      :class="
        titleAlign === 'left'
          ? 'min-[960px]:text-left'
          : titleAlign === 'right'
            ? 'min-[960px]:text-right'
            : 'min-[960px]:text-center'
      "
    >
      {{ titleText }}
    </h2>

    <!-- Description: 14px font-medium #787882 for all breakpoints -->
    <div
      v-if="showDescription"
      class="flex items-center justify-center gap-2 mt-2 bp960:mt-1"
    >
      <slot name="description">
        <div
          :class="descriptionClass"
          class="text-[#787882] dark:text-slate-400 text-[14px] font-medium whitespace-pre-line"
        >
          {{ description }}
        </div>
      </slot>
    </div>
  </div>
</template>
